 
import React, {useState, useEffect} from "react";
import {marked} from "marked";

interface MarkdownViewerProps {
    text: string;
}

export const MarkdownViewer: React.FC<MarkdownViewerProps> = ({text}) => {
    const [content, setContent] = useState<string>("");

    /**
     * Anchor links are not handled well by 'marked' and result in HTTP 404 errors as the URL they point to does not exist.
     * This function removes them from the resulted HTML.
     */
    const removeAnchorLinks = (html: string) => {
        const ancorLinksRegex = /<a\s+(?:[^>]*?\s+)?href=['"](#[^"']*?)['"][^>]*?>/g;
        return html.replace(ancorLinksRegex, "");
    };

    useEffect(() => {
        try {
            const parsedHtml = marked.parse(text);
            const cleanedHtml = removeAnchorLinks(parsedHtml);
            setContent(cleanedHtml);
        } catch (error: any) {
            // Fallback: Display raw text (escaped for safety) if parsing fails
            const escapedText = text.replace(/</g, "&lt;").replace(/>/g, "&gt;");
            setContent(escapedText);
        }
    }, [text]);

    return <span dangerouslySetInnerHTML={{__html: content}} />;
};
